import { c as _c } from "react/compiler-runtime";
import { ElementType } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import NavLink, { Props as NavLinkProps } from '../NavLink';
export type Props<C extends ElementType = ElementType> = Omit<NavLinkProps<C>, 'startIcon' | 'endIcon'>;
const BackLink = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <ArrowBackIcon />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <NavLink startIcon={t0} {...props} />;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default BackLink;